import { render, staticRenderFns } from "./CarrinhoOfertaIpi.vue?vue&type=template&id=30f867d6"
import script from "./CarrinhoOfertaIpi.vue?vue&type=script&lang=js"
export * from "./CarrinhoOfertaIpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports